import { cn } from '@/utils';

interface ManagerTableCellLabelProps {
  /** The text label to display in the table cell */
  label: string;
}

/**
 * ManagerTableCellLabel Component
 *
 * This component is a simple wrapper for displaying text labels within table cells
 * in the Manager Dashboard. It applies consistent styling to ensure that all labels
 * have the same appearance, specifically using a smaller font size and a neutral
 * gray color. The component accepts a `label` prop which is the text to be displayed,
 * and it can also accept additional props that are spread onto the root <span> element.
 */
export const ManagerTableCellLabel: React.FC<ManagerTableCellLabelProps> = ({
  label,
  ...props
}) => {
  return (
    <span
      className={cn('text-sm text-neutral-gray-700', { 'text-neutral-gray-500': label === '—' })}
      {...props}
    >
      {label}
    </span>
  );
};

ManagerTableCellLabel.displayName = 'ManagerTableCellLabel';

export default ManagerTableCellLabel;
